module.exports = __webpack_public_path__ + "img/1.1d8f3f86.jpg";